export default "__VITE_ASSET__D7fR3Qab__"